import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/Home/HomeView.vue";

//AUTH VIEWS
import RegisterView from "../views/Auth/RegisterView.vue";
import RegisterSuccessView from "../views/Auth/RegisterSuccess.vue";
import RegisterCompleteView from "../views/Auth/RegisterComplete.vue";
import LoginView from "../views/Auth/LoginView.vue";
import ForgotPasswordView from "../views/Auth/ForgotPassword.vue";
import ForgotSuccessView from "../views/Auth/ForgotSuccess.vue";
import ResetPasswordView from "../views/Auth/ResetPassword.vue";

// DASHBOARD
import DashboardView from "../views/Dashboard/DashboardView";
import DashboardOverView from "../views/Dashboard/DashboardOverview";
import DashboardSendSMSView from "../views/Dashboard/DashboardSendSMS";
import DashboardSentSMSView from "../views/Dashboard/DashboardSentSMS";
import DashboardTemplateSMSView from "../views/Dashboard/DashboardTemplateSMS";
import DashboardContactView from "../views/Dashboard/DashboardContact";
import DashboardGroupView from "../views/Dashboard/DashboardGroup";
import DashboardSenderIdView from "../views/Dashboard/DashboardSenderId";
import DashboardWalletView from "../views/Dashboard/DashboardWallet";
import DashboardTransactionView from "../views/Dashboard/DashboardTransaction";
import DashboardBalanceView from "../views/Dashboard/DashboardBalanceSwap";
import DashboardReferralView from "../views/Dashboard/DashboardReferral";
import DashboardSettingView from "../views/Dashboard/DashboardSetting";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/signup",
    name: "signup",
    component: RegisterView,
  },
  {
    path: "/register-success",
    name: "register-success",
    component: RegisterSuccessView,
  },
  {
    path: "/register-complete/:token",
    name: "register-complete",
    component: RegisterCompleteView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordView,
  },
  {
    path: "/forgot-succcess",
    name: "forgot-succcess",
    component: ForgotSuccessView,
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: ResetPasswordView,
  },
  {
    path: "/dashboard",
    // name: "dashboard",
    component: DashboardView,
    meta: { requiresAuth: true },
    children: [
      // Define the child routes
      {
        path: "stats",
        name: "stats",
        component: DashboardOverView,
      },
      {
        path: "wallet",
        name: "wallet",
        component: DashboardWalletView,
      },
      {
        path: "sent-sms",
        name: "sent-sms",
        component: DashboardSentSMSView,
      },
      {
        path: "sms-template",
        name: "sms-template",
        component: DashboardTemplateSMSView,
      },
      {
        path: "contacts",
        name: "contacts",
        component: DashboardContactView,
      },
      {
        path: "groups",
        name: "groups",
        component: DashboardGroupView,
      },
      {
        path: "senderid",
        name: "senderid",
        component: DashboardSenderIdView,
      },
      {
        path: "send-sms",
        name: "send-sms",
        component: DashboardSendSMSView,
      },
      {
        path: "transactions",
        name: "transactions",
        component: DashboardTransactionView,
      },
      {
        path: "balance-swap",
        name: "balance-swap",
        component: DashboardBalanceView,
      },
      {
        path: "referrals",
        name: "referrals",
        component: DashboardReferralView,
      },
      {
        path: "settings",
        name: "settings",
        component: DashboardSettingView,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }; // Scroll to top when navigating to a new page
    }
  },
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("user");

  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next("/login");
  }
  next();
});

export default router;
